/* eslint-disable max-len */
import React from 'react';

interface ShowProps {
    color?: string;
}

const Show: React.FC<ShowProps> = ({color = '#616E6E'}) => {

    return (
        <svg
            width="12"
            height="10"
            viewBox="0 0 12 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M6.00052 0.375C7.68385 0.375 9.03177 1.16562 10.013 2.10664C10.988 3.03906 11.6401 4.15625 11.9484 4.92324C12.0172 5.09297 12.0172 5.28203 11.9484 5.45176C11.6401 6.21875 10.988 7.33594 10.013 8.26836C9.03177 9.20937 7.68385 10 6.00052 10C4.31719 10 2.96927 9.20937 1.98802 8.26836C1.01302 7.33379 0.360938 6.21875 0.0505219 5.45176C-0.0182285 5.28203 -0.0182285 5.09297 0.0505219 4.92324C0.360938 4.15625 1.01302 3.03906 1.98802 2.10664C2.96927 1.16562 4.31719 0.375 6.00052 0.375ZM9.00052 5.1875C9.00052 4.36699 8.68445 3.58008 8.12184 2.99989C7.55923 2.4197 6.79617 2.09375 6.00052 2.09375C5.20487 2.09375 4.44181 2.4197 3.8792 2.99989C3.31659 3.58008 3.00052 4.36699 3.00052 5.1875C3.00052 6.00801 3.31659 6.79492 3.8792 7.37511C4.44181 7.9553 5.20487 8.28125 6.00052 8.28125C6.79617 8.28125 7.55923 7.9553 8.12184 7.37511C8.68445 6.79492 9.00052 6.00801 9.00052 5.1875ZM6.00052 3.8125C6.00052 4.5709 6.59844 5.1875 7.33385 5.1875C7.48177 5.1875 7.62344 5.16172 7.75677 5.1166C7.87135 5.07793 8.00469 5.15098 8.00052 5.27559C7.99427 5.42383 7.97344 5.57207 7.93385 5.72031C7.64844 6.82031 6.55052 7.47344 5.48385 7.1791C4.41719 6.88477 3.78385 5.75254 4.06927 4.65254C4.30052 3.76094 5.0651 3.16152 5.9151 3.125C6.03594 3.1207 6.10677 3.25605 6.06927 3.37637C6.02552 3.51387 6.00052 3.65996 6.00052 3.8125Z"
                fill={color}
            />
        </svg>
    );
};

export default Show;

